import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "commons/store/store";
import {
  UserForgotPasswordRequestInputUserUserWrite,
  UserResetPasswordRequestUserUserWrite,
  UserUserUserReadIdRead,
} from "types/api.types";
import axiosPublicInstance from "commons/axios/axiosPublicInstance";
import axiosSecureInstance from "commons/axios/axiosSecureInstance";
import {getRoleByToken, getRoles, saveToken} from "commons/auth/tokens";

interface Page {
  page: any;
  data: any;
  name: string;
}

const initialState: Page = {
  page: [],
  data: [],
  name: '',
};

export const fetchPageData = createAsyncThunk(
  'page/fetchPage',
  async (slug: any, thunkAPI) => {
    try {
      const response = await axiosPublicInstance.get<any[]>(
        `/api/pages/${slug}/data`
      );
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
)

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPageData.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  },
});

export const selectPage = (state: RootState) => state.core.page.page;
export const selectPageData = (state: RootState) => state.core.page.data;

export default pageSlice.reducer;
